import FullScreenPanel from "./FullScreenPanel";
import MenuButton from "./MenuButton";

interface PracticeRoundCompletePanelProps {
  onDismiss: () => void;
}

export default function PracticeRoundCompletePanel(
  props: PracticeRoundCompletePanelProps,
) {
  return (
    <FullScreenPanel
      heading="Practice Level Complete"
      hideCloseButton={true}
      panelClassName="lg:h-auto justify-center"
    >
      <div className="flex flex-col h-full justify-start items-center gap-5 mt-5">
        <p>You're ready to play Pixellence.</p>
        <MenuButton className="mb-5" onClick={props.onDismiss}>
          Let's do it
        </MenuButton>
      </div>
    </FullScreenPanel>
  );
}
